import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type CountryKey = 'us' | 'india' | 'uk' | 'eu';

interface LiveCountriesState {
  liveCountries: Record<CountryKey, boolean>;
  isLive: (country: CountryKey) => boolean;
  setLive: (country: CountryKey, live: boolean) => void;
  resetDefaults: () => void;
}

const DEFAULTS: Record<CountryKey, boolean> = {
  us: true,
  india: true,
  uk: true,
  eu: false,
};

export const useLiveCountriesStore = create<LiveCountriesState>()(
  persist(
    (set, get) => ({
      liveCountries: { ...DEFAULTS },
      isLive: (country) => !!get().liveCountries[country],
      setLive: (country, live) =>
        set((state) => ({
          liveCountries: { ...state.liveCountries, [country]: live },
        })),
      resetDefaults: () => set({ liveCountries: { ...DEFAULTS } }),
    }),
    {
      name: 'live-countries-storage',
    }
  )
);
